module.exports = __webpack_public_path__ + "img/googleslide-addin-02.0ebc1f73.png";